import "core-js/modules/es.array.reverse.js";
var _class, _ThreddsStratum, _class2, _ThreddsCatalogGroup;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable, override } from "mobx";
import threddsCrawler from "thredds-catalog-crawler/src/entryBrowser";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ThreddsCatalogGroupTraits from "../../../Traits/TraitsClasses/ThreddsCatalogGroupTraits";
import CatalogGroup from "../CatalogGroup";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import { proxyCatalogItemBaseUrl } from "../proxyCatalogItemUrl";
import StratumOrder from "../../Definition/StratumOrder";
import ThreddsItemReference from "../CatalogReferences/ThreddsItemReference";
export let ThreddsStratum = (_class = (_ThreddsStratum = class ThreddsStratum extends LoadableStratum(ThreddsCatalogGroupTraits) {
  constructor(_catalogGroup) {
    super();
    this._catalogGroup = _catalogGroup;
    _defineProperty(this, "threddsCatalog", undefined);
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new ThreddsStratum(model);
  }
  static async load(catalogGroup) {
    return new ThreddsStratum(catalogGroup);
  }
  get members() {
    if (this.threddsCatalog === undefined) return [];
    const memberIds = [];
    this.threddsCatalog.catalogs.forEach(catalog => {
      memberIds.push("".concat(this._catalogGroup.uniqueId, "/").concat(catalog.id));
    });
    this.threddsCatalog.datasets.forEach(dataset => {
      dataset.catalogs.forEach(c => {
        memberIds.push("".concat(this._catalogGroup.uniqueId, "/").concat(c.id));
      });
      memberIds.push("".concat(this._catalogGroup.uniqueId, "/").concat(dataset.id));
    });
    return memberIds;
  }
  createThreddsCatalog(catalog) {
    const id = "".concat(this._catalogGroup.uniqueId, "/").concat(catalog.id);
    let model = this._catalogGroup.terria.getModelById(ThreddsCatalogGroup, id);
    if (!isDefined(model)) {
      model = new ThreddsCatalogGroup(id, this._catalogGroup.terria);
      this._catalogGroup.terria.addModel(model);
    }
    model.setTrait(CommonStrata.definition, "name", catalog.title);
    model.setTrait(CommonStrata.definition, "url", catalog.url);
  }
  async createMembers() {
    if (!isDefined(this._catalogGroup.url)) return;
    const proxy = proxyCatalogItemBaseUrl(this._catalogGroup, this._catalogGroup.url);
    this.threddsCatalog = await threddsCrawler(this._catalogGroup.url, proxy ? {
      proxy
    } : undefined);
    if (this.threddsCatalog === undefined) return;
    // Create sub-groups for any nested catalogs
    for (let i = 0; i < this.threddsCatalog.catalogs.length; i++) {
      this.createThreddsCatalog(this.threddsCatalog.catalogs[i]);
    }

    // Create members for individual datasets
    for (let i = 0; i < this.threddsCatalog.datasets.length; i++) {
      const ds = this.threddsCatalog.datasets[i];
      await ds.loadAllNestedCatalogs();
      for (let ii = 0; ii < ds.catalogs.length; ii++) {
        this.createThreddsCatalog(ds.catalogs[ii]);
      }
      if (ds.isParentDataset) {
        let parent = this._catalogGroup;
        if (this.threddsCatalog.datasets.length > 1) {
          const id = "".concat(this._catalogGroup.uniqueId, "/").concat(ds.id);
          let model = this._catalogGroup.terria.getModelById(CatalogGroup, id);
          if (!isDefined(model)) {
            model = new CatalogGroup(id, this._catalogGroup.terria);
            this._catalogGroup.terria.addModel(model);
          }
          model.setTrait(CommonStrata.definition, "name", ds.name);
          parent = model;
        }
        ds.datasets.forEach(dataset => {
          const item = this.createMemberFromDataset(dataset);
          if (item !== undefined) parent.add(CommonStrata.definition, item);
        });
      } else if (ds.supportsWms) {
        this.createMemberFromDataset(ds);
      }
    }
  }
  createMemberFromDataset(threddsDataset) {
    if (!isDefined(threddsDataset.id)) {
      return undefined;
    }
    const itemId = this._catalogGroup.uniqueId + "/" + threddsDataset.id;
    let item = this._catalogGroup.terria.getModelById(ThreddsItemReference, itemId);
    if (item === undefined) {
      item = new ThreddsItemReference(itemId, this._catalogGroup.terria);
      item.setTrait(CommonStrata.definition, "isGroup", true);
      item.setDataset(threddsDataset);
      item.setThreddsStrata(item);
      item.terria.addModel(item);
    }
    return item;
  }
}, _defineProperty(_ThreddsStratum, "stratumName", "thredds"), _ThreddsStratum), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createThreddsCatalog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createThreddsCatalog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromDataset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromDataset"), _class.prototype), _class);
StratumOrder.addLoadStratum(ThreddsStratum.stratumName);
let ThreddsCatalogGroup = (_class2 = (_ThreddsCatalogGroup = class ThreddsCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(ThreddsCatalogGroupTraits)))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return ThreddsCatalogGroup.type;
  }
  get typeName() {
    return i18next.t("models.thredds.nameGroup");
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  async forceLoadMetadata() {
    if (!this.strata.get(ThreddsStratum.stratumName)) {
      const stratum = await ThreddsStratum.load(this);
      if (stratum === undefined) return;
      await stratum.createMembers();
      runInAction(() => {
        this.strata.set(ThreddsStratum.stratumName, stratum);
      });
    }
  }
  async forceLoadMembers() {
    const stratum = this.strata.get(ThreddsStratum.stratumName);
    if (stratum) {
      await stratum.createMembers();
    }
  }
}, _defineProperty(_ThreddsCatalogGroup, "type", "thredds-group"), _ThreddsCatalogGroup), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _class2);
export { ThreddsCatalogGroup as default };